module.exports = __webpack_public_path__ + "media/images/placeholders/product-497c83d85cf8405d4af297c85f848456.jpg";